/* eslint-disable react/jsx-one-expression-per-line */
// @ts-ignore
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
// @ts-ignore
import { Dropdown } from '@els/els-react--dropdown';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
// @ts-ignore
import { Toast } from '@els/els-react--toast';
// @ts-ignore
import { Paginator } from '@els/els-react--paginator';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import { Banner } from '@els/els-react--banner';
import {
    isPending,
    hasFailed,
    hasSucceeded,
    isComplete,
} from '../../../libs/utils/constants/async-status';
import { relevanceFilterDropdown } from '../../constants/skills-sort-order';
import LeftFilterPanel from './left-filter-panel';
import SearchedSkillCard from './searched-skill-card';
import {
    getAllActiveSkills,
    getAllHSearchSkills,
    postAddFavoriteFilters,
    getFavoriteFilters,
    editFavoriteFilters,
    getQuickLinks,
    getRecentViewedSkills,
    getBrowseSkillsOrPatientEducations,
} from './search-thunk';
import {
    selectClientId,
    selectUserId,
    selectIsUserAdmin,
    selectUserAuthenticationStatus,
} from '../login/login-selector';
import {
    IHSearchSkillDetails,
    IHSearchFacetData,
} from '../../../libs/utils/interfaces/search-interface';
import {
    selectAllActiveCourseIdentifierSkills,
    selectAllActiveSkillAsyncStatus,
    selectHSearchSkillAsyncStatus,
    selectHSearchSkillNumRows,
    selectHSearchSkillsDetails,
    selectAddOrEditFavoriteFiltersAsyncStatus,
    selectAllActiveSkillsDetails,
    selectGetFavoriteFiltersAsyncStatus,
    selectFavoriteFilters,
    selectQuickLinks,
    selectQuickLinksAsyncStatus,
    selectHSCSContentAsyncStatus,
    selectHSearchFacetData,
    selectSearchPageState,
    selectIsNavigatingBackToSearch,
} from './search-selector';
import {
    selectReferentialAccessAsyncStatus,
    selectIsIpWhitelistedAsyncStatus,
    selectClientId as selectClientIdforReference,
} from '../referential-access/referential-access-selector';
import {
    HSearchContentType,
    HSearchFilters,
    NSKSearchFilter,
    PESearchFilter,
    AgeFilterTitles,
    PatientEducationTypeTitles,
} from '../../constants/h-search';
import {
    selectTypeOfContentForClientAsyncStatus,
    selectTypeOfContentForClient,
} from '../home/home-selector';
import { getTypeOfContentExistsForClientThunk } from '../home/home-thunk';
import './search.scss';
import { saveSearchPageState, setNavigatingBackToSearch } from './search-slice';
import DefaultFilterConfirmationModal from './components/default-filter-confirmation-modal';
// import DefaultFilterButton from './components/default-filter-button'; // This code will be used in CLH Phase 4
import SelectedPills from './components/selected-pills';
import NoSearchResults from '../../components/no-search-results/no-search-results';
import WarnBanner from '../../components/warn-banner/warn-banner';
import AutoSuggestComponent from '../../components/auto-suggest/auto-suggest';
import AriaLiveAnnouncer from '../../components/aria-live-announcer/aria-live-announcer';
import BackButtonNavigationTracking from '../../utils/back-button-helper';
import { isLatestStateEquivalentToRestored } from '../../utils/helper';
import { cancelledAsyncLogin } from '../login/login-slice';
import { selectSendSkillsEmailAsyncStatus } from '../../components/email-modal/email-selector';
import { resetSendPatientEducationEmailAsyncStatus } from '../../components/email-modal/email-slice';
import { PageTitle } from '../../utils/page-title';
import {
    selectEnrolledSkills,
    selectEnrolledSkillsAsyncStatus,
} from './self-enrollment/self-enrollment-selector';
import { getEnrolledSkills } from './self-enrollment/self-enrollment-thunk';
import {
    IEnrolledSkill,
    SELF_ENROLLMENT_UPDATE_EVENT,
} from '../../constants/self-enrollment';
import { selectAppConfigs } from '../app-config/app-config-selector';
import { setEventSelfEnrolledCourseId } from './self-enrollment/self-enrollment-slice';

interface SortByOption {
    value: string;
    label: string;
}
const NO_OF_RESULTS_PER_PAGE = 25;
const Search = () => {
    const dispatch = useDispatch();
    const hscsAsyncStatus = useSelector(selectHSCSContentAsyncStatus);
    const [currentPage, setCurrentPage] = useState(1);
    const limit = NO_OF_RESULTS_PER_PAGE;
    const startIndex = 0;
    let offset = (currentPage - 1) * limit;
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const querySearchKeyword = params.get('keyword') || '';
    const querySearchContentType =
        params.get('content_type') || HSearchContentType.CLINICALSKILLS;
    const [keyword, setKeyword] = useState(querySearchKeyword);
    const [previousKeyword, setPreviousKeyword] = useState('');
    const [contentType, setContentType] = useState(querySearchContentType);
    const [ageSpecific, setAgeSpecific] = useState('');
    const [subType, setSubType] = useState('');
    const [category, setCategory] = useState('');
    const [speciality, setSpeciality] = useState('');
    const { ecrId } = useParams<{ ecrId: string }>();
    const [sortOrderBy, setSortOrderBy] = useState('asc');
    const searchObj = {
        keyword,
        contentType,
        skillIds: '',
        start: startIndex,
        rows: NO_OF_RESULTS_PER_PAGE,
        sortItem: relevanceFilterDropdown[0].value,
        sortOrder: sortOrderBy,
        ageSpecific,
        subType,
        category,
        speciality,
        nursingSkillsClientId: ecrId,
    };
    const browseObject = {
        contentType,
        skillIds: '',
        start: startIndex,
        rows: NO_OF_RESULTS_PER_PAGE,
        ageSpecific,
        subType,
        category,
        speciality,
        nursingSkillsClientId: ecrId,
    };
    const [sortBy, setSortBy] = useState(relevanceFilterDropdown[0].label);
    const [searchPayload, setSearchPayload] = useState(searchObj);
    const [browsePayload, setBrowsePayload] = useState(browseObject);
    const baseClassName = 'search';
    const [isOverlayVisible, setOverlayVisible] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);
    const [isBannerVisible, setIsBannerVisible] = useState(true);
    const [isDefaultFilterBannerVisible, setIsDefaultFilterBannerVisible] =
        useState<Boolean>(true);
    const [filterFacetData, setFilterFacetData] = useState([]);
    const [isSubTypeMedication, setIsSubTypeMedication] = useState(false);
    const [isOverlayLoaderVisible, setOverlayLoaderVisible] = useState(false);
    const [showCancelSuccessToast, setShowCancelSuccessToast] = useState(false);

    const isUserloggedIn: boolean = useSelector(selectUserAuthenticationStatus);
    const clientIdFromLogin = useSelector(selectClientId);
    const clientIdFromReferential = useSelector(selectClientIdforReference);
    const clientId: number = isUserloggedIn
        ? clientIdFromLogin
        : clientIdFromReferential;
    const userId = useSelector(selectUserId);
    const searchSkillList: Array<IHSearchSkillDetails> = useSelector(
        selectHSearchSkillsDetails
    );
    const searchFacetData: Array<IHSearchFacetData> = useSelector(
        selectHSearchFacetData
    );
    const hSearchAsyncStatus = useSelector(selectHSearchSkillAsyncStatus);
    const addOrEditFavoriteFiltersStatus = useSelector(
        selectAddOrEditFavoriteFiltersAsyncStatus
    );
    const getFavoriteFiltersStatus = useSelector(
        selectGetFavoriteFiltersAsyncStatus
    );
    const favoriteFilters = useSelector(selectFavoriteFilters);
    const allSkillAsyncStatus = useSelector(selectAllActiveSkillAsyncStatus);
    const totalNoOfRows = useSelector(selectHSearchSkillNumRows);
    const allActiveSkillCourseIdentifier = useSelector(
        selectAllActiveCourseIdentifierSkills
    );
    const [isFilterSaveConfirmationModal, setIsFilterSaveConfirmationModal] =
        useState<boolean>(false);
    const allActiveSkillsDetails = useSelector(selectAllActiveSkillsDetails);
    const isUserAdmin = useSelector(selectIsUserAdmin);
    const enrolledSkills = useSelector(selectEnrolledSkills);
    const enrolledSkillsAsyncStatus = useSelector(
        selectEnrolledSkillsAsyncStatus
    );
    const [isEnrolledSkillsBannerVisible, setIsEnrolledSkillsBannerVisible] =
        useState(true);

    const onCloseEnrolledSkillsBanner = () => {
        setIsEnrolledSkillsBannerVisible(false);
    };

    useEffect(() => {
        if (hasFailed(enrolledSkillsAsyncStatus)) {
            setIsEnrolledSkillsBannerVisible(true);
        }
    }, [enrolledSkillsAsyncStatus]);
    const isReferentialAsyncStatus = useSelector(
        selectReferentialAccessAsyncStatus
    );
    const isIpWhitelistedAsyncStatus = useSelector(
        selectIsIpWhitelistedAsyncStatus
    );
    const contentTypeLicensedAsyncStatus = useSelector(
        selectTypeOfContentForClientAsyncStatus
    );
    const contentTypeLicensedByClient = useSelector(
        selectTypeOfContentForClient
    );
    const appConfigs = useSelector(selectAppConfigs);
    const englishLanguageCode = 'eng';
    const isKeywordPresent = keyword.length > 0;
    const searchPageState = useSelector(selectSearchPageState);
    const [filtersApplied, setFiltersApplied] = useState(
        [
            querySearchContentType,
            searchPageState.ageSpecific,
            searchPageState.subType,
            searchPageState.category,
            searchPageState.speciality,
        ].filter((val) => val !== '').length
    );
    const [currentFilters, setCurrentFilters] = useState({
        contentType,
        ageSpecific,
        subType,
        speciality,
        category,
    });

    const [selectedRadioOption, setSelectedRadioOption] = useState<{
        [key: string]: string;
    }>(() => ({
        contentType: currentFilters?.contentType,
        ageSpecific,
        subType,
        speciality,
        category,
    }));

    const isNavigatingBackToSearch = useSelector(
        selectIsNavigatingBackToSearch
    );
    const [isSearchPageStateRestored, setIsSearchPageStateRestored] =
        useState(false);

    const restoredStateRef = useRef<any>(null);
    const sendPatientEducationEmailStatus = useSelector(
        selectSendSkillsEmailAsyncStatus
    );
    const selfEnrollmentIdBySkillId = useMemo(() => {
        if (!Array.isArray(enrolledSkills)) {
            return {};
        }
        return enrolledSkills.reduce(
            (
                acc: { [key: number]: IEnrolledSkill },
                enrolled: IEnrolledSkill
            ) => {
                acc[enrolled.skillId] = enrolled;
                return acc;
            },
            {}
        );
    }, [enrolledSkills]);
    useEffect(() => {
        if (
            isNavigatingBackToSearch &&
            searchPageState &&
            searchPageState.keyword !== undefined
        ) {
            setKeyword(searchPageState.keyword);
            setContentType(searchPageState.contentType);
            setAgeSpecific(searchPageState.ageSpecific);
            setSubType(searchPageState.subType);
            setCategory(searchPageState.category);
            setSpeciality(searchPageState.speciality);
            setSortBy(
                searchPageState.sortItem || relevanceFilterDropdown[0].label
            );
            setSortOrderBy(searchPageState.sortOrder || 'asc');
            setCurrentPage(searchPageState.currentPage || 1);
            setIsSubTypeMedication(
                searchPageState.isSubTypeMedication || false
            );
            setSelectedRadioOption(
                searchPageState.selectedRadioOption || {
                    contentType: searchPageState.contentType,
                    ageSpecific: searchPageState.ageSpecific,
                    subType: searchPageState.subType,
                    category: searchPageState.category,
                    speciality: searchPageState.speciality,
                }
            );
            setOverlayVisible(searchPageState.isOverlayVisible || false);
            setCurrentFilters({
                contentType: searchPageState.contentType,
                ageSpecific: searchPageState.ageSpecific,
                subType: searchPageState.subType,
                category: searchPageState.category,
                speciality: searchPageState.speciality,
            });
            setFiltersApplied(
                [
                    searchPageState.contentType,
                    searchPageState.ageSpecific,
                    searchPageState.subType,
                    searchPageState.category,
                    searchPageState.speciality,
                ].filter((val) => val !== '').length
            );
            setSearchPayload({
                ...searchPageState,
                skillIds: allActiveSkillCourseIdentifier.join(','),
                rows: NO_OF_RESULTS_PER_PAGE,
                start:
                    ((searchPageState.currentPage || 1) - 1) *
                    NO_OF_RESULTS_PER_PAGE,
                nursingSkillsClientId: ecrId,
            });
            setBrowsePayload({
                ageSpecific: searchPageState.ageSpecific || '',
                category: searchPageState.category || '',
                contentType: searchPageState.contentType,
                nursingSkillsClientId: ecrId,
                rows: NO_OF_RESULTS_PER_PAGE,
                skillIds: allActiveSkillCourseIdentifier.join(','),
                speciality: searchPageState.speciality || '',
                start:
                    ((searchPageState.currentPage || 1) - 1) *
                    NO_OF_RESULTS_PER_PAGE,
                subType: searchPageState.subType || '',
            });
            const restoredPayload = {
                ...searchPageState,
                skillIds: allActiveSkillCourseIdentifier.join(','),
                start:
                    ((searchPageState.currentPage || 1) - 1) *
                    NO_OF_RESULTS_PER_PAGE,
                rows: NO_OF_RESULTS_PER_PAGE,
                nursingSkillsClientId: ecrId,
            };
            const restoredBrowsePayload = {
                ageSpecific: searchPageState.ageSpecific || '',
                category: searchPageState.category || '',
                contentType: searchPageState.contentType,
                nursingSkillsClientId: ecrId,
                rows: NO_OF_RESULTS_PER_PAGE,
                skillIds: allActiveSkillCourseIdentifier.join(','),
                speciality: searchPageState.speciality || '',
                start:
                    ((searchPageState.currentPage || 1) - 1) *
                    NO_OF_RESULTS_PER_PAGE,
                subType: searchPageState.subType || '',
            };
            setIsBannerVisible(false);
            setIsDefaultFilterBannerVisible(false);
            if (searchPageState.keyword && searchPageState.keyword.length > 0) {
                dispatch(getAllHSearchSkills(restoredPayload));
            } else {
                dispatch(
                    getBrowseSkillsOrPatientEducations(restoredBrowsePayload)
                );
            }
            restoredStateRef.current = {
                keyword: searchPageState.keyword,
                contentType: searchPageState.contentType,
                ageSpecific: searchPageState.ageSpecific,
                subType: searchPageState.subType,
                category: searchPageState.category,
                speciality: searchPageState.speciality,
                sortItem:
                    searchPageState.sortItem ||
                    relevanceFilterDropdown[0].label,
                sortOrder: searchPageState.sortOrder || 'asc',
                currentPage: searchPageState.currentPage || 1,
                isSubTypeMedication:
                    searchPageState.isSubTypeMedication || false,
                selectedRadioOption: searchPageState.selectedRadioOption || {
                    contentType: searchPageState.contentType,
                    ageSpecific: searchPageState.ageSpecific,
                    subType: searchPageState.subType,
                    category: searchPageState.category,
                    speciality: searchPageState.speciality,
                },
                isOverlayVisible: searchPageState.isOverlayVisible || false,
            };
            setTimeout(() => {
                dispatch(setNavigatingBackToSearch(false));
                setIsSearchPageStateRestored(true);
            }, 50);
        }
    }, [isNavigatingBackToSearch]);

    useEffect(() => {
        dispatch(getTypeOfContentExistsForClientThunk(clientId));
    }, [dispatch, clientId]);

    useEffect(() => {
        let handleResize: (() => void) | undefined;
        if (!isNavigatingBackToSearch) {
            handleResize = () => {
                setIsMobileView(window.innerWidth <= 320);
            };
            handleResize();
            if (allActiveSkillsDetails.length === 0) {
                dispatch(getAllActiveSkills({ clientId, ecrId }));
            }
            if (clientId !== -1 && userId !== -1) {
                dispatch(getRecentViewedSkills());
                dispatch(getFavoriteFilters());
            }
            window.addEventListener('resize', handleResize);
        }

        return () => {
            if (handleResize) {
                window.removeEventListener('resize', handleResize);
            }
        };
    }, [isNavigatingBackToSearch]);

    useEffect(() => {
        if (!allActiveSkillsDetails || allActiveSkillsDetails.length === 0) {
            return;
        }
        if (!isNavigatingBackToSearch && allActiveSkillsDetails.length > 0) {
            if (
                !isPending(hSearchAsyncStatus) &&
                !isPending(allSkillAsyncStatus)
            ) {
                if (querySearchKeyword !== '') {
                    const payload = {
                        ...searchPayload,
                        skillIds: allActiveSkillCourseIdentifier.join(','),
                    };
                    getSearchSkills(payload);
                } else if (keyword === '') {
                    const browseUpdatedPayload = {
                        ...browsePayload,
                        skillIds: allActiveSkillCourseIdentifier.join(','),
                    };
                    getBrowseSkillsOrPatientEducation(browseUpdatedPayload);
                }
            }
        }
    }, [allActiveSkillsDetails, isNavigatingBackToSearch]);

    useEffect(() => {
        if (
            hasSucceeded(hSearchAsyncStatus) &&
            searchSkillList?.length > 0 &&
            contentType === HSearchContentType.CLINICALSKILLS
        ) {
            const courseIds = searchSkillList.map(
                (skill) =>
                    allActiveSkillsDetails.find(
                        (activeSkill: { courseIdentifier: string }) =>
                            activeSkill.courseIdentifier === skill.skillid
                    )?.id
            );
            dispatch(
                getQuickLinks({ courseIds: courseIds.toString(), clientId })
            );
            const validCourseIds = courseIds.filter(
                (id): id is number => id !== undefined
            );
            if (validCourseIds.length > 0 && userId !== -1) {
                dispatch(
                    getEnrolledSkills({
                        skillIds: validCourseIds,
                    })
                );
            }
        }
        if (
            hasSucceeded(hSearchAsyncStatus) &&
            searchSkillList?.length === 0 &&
            contentType === HSearchContentType.CLINICALSKILLS &&
            keyword !== previousKeyword
        ) {
            setPreviousKeyword(keyword);
            handleChange(
                HSearchFilters.CONTENTTYPE,
                HSearchContentType.PATIENTEDUCATION
            );
        }
    }, [searchSkillList, contentType]);

    useEffect(() => {
        if (
            hasSucceeded(sendPatientEducationEmailStatus) ||
            isPending(sendPatientEducationEmailStatus)
        ) {
            dispatch(resetSendPatientEducationEmailAsyncStatus());
        }
    }, [dispatch, sendPatientEducationEmailStatus]);

    const saveSearchState = () => {
        const latestState = {
            keyword,
            contentType,
            ageSpecific,
            subType,
            category,
            speciality,
            sortItem: relevanceFilterDropdown[0].value || sortBy,
            sortOrder: sortOrderBy,
            currentPage,
            isSubTypeMedication,
            selectedRadioOption,
            isOverlayVisible,
        };
        const compareState = restoredStateRef.current || searchPageState;
        if (isLatestStateEquivalentToRestored(latestState, compareState)) {
            dispatch(saveSearchPageState({}));
        } else {
            dispatch(saveSearchPageState(latestState));
        }
    };

    const toggleOverlay = () => {
        setOverlayVisible(!isOverlayVisible);
    };

    useEffect(() => {
        if (!(localStorage.getItem('IS_USER_AUTHENTICATED') === 'true')) {
            dispatch(cancelledAsyncLogin());
        }
        const handleResize = () => {
            if (window.innerWidth > 900) {
                setOverlayVisible(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSearchClick = (searchText: string) => {
        if (searchText.trim() === '') {
            setTimeout(() => {
                setSearchPageAnnouncement(
                    'Enter a keyword and press the Search button to view results'
                );
            }, 300);
        }
        // Reset filters
        setAgeSpecific('');
        setSubType('');
        setCategory('');
        setSpeciality('');
        setSelectedRadioOption({
            contentType,
            ageSpecific: '',
            subType: '',
            speciality: '',
            category: '',
        });
        setCurrentFilters({
            contentType,
            ageSpecific: '',
            subType: '',
            category: '',
            speciality: '',
        });
        setCurrentPage(1);
        setSortBy(relevanceFilterDropdown[0].label);
        setSortOrderBy('asc');
        const payload = {
            keyword: searchText,
            contentType,
            skillIds: allActiveSkillCourseIdentifier.join(','),
            start: 0,
            rows: NO_OF_RESULTS_PER_PAGE,
            sortItem: relevanceFilterDropdown[0].value,
            sortOrder: 'asc',
            ageSpecific: '',
            subType: '',
            category: '',
            speciality: '',
            nursingSkillsClientId: ecrId,
        };
        setKeyword(searchText);
        getSearchSkills(payload);
        setFiltersApplied(
            [
                payload.contentType,
                payload.ageSpecific,
                payload.subType,
                payload.category,
                payload.speciality,
            ].filter((val) => val !== '').length
        );
    };

    const onPageChangeHandler = (page: number) => {
        setCurrentPage(page);
        offset = (page - 1) * limit;
        let payload;
        if (isSearchPageStateRestored && searchPageState.contentType) {
            payload = {
                ...searchPageState,
                skillIds: allActiveSkillCourseIdentifier.join(','),
                rows: NO_OF_RESULTS_PER_PAGE,
                start: (page - 1) * NO_OF_RESULTS_PER_PAGE,
                nursingSkillsClientId: ecrId,
            };
            setCurrentPage(page);
            setKeyword(payload.keyword);
            setContentType(payload.contentType);
            setAgeSpecific(payload.ageSpecific);
            setSubType(payload.subType);
            setCategory(payload.category);
            setSpeciality(payload.speciality);
            setIsSubTypeMedication(payload.isSubTypeMedication || false);
            setSelectedRadioOption(payload.selectedRadioOption || {});
            setOverlayVisible(payload.isOverlayVisible || false);
            setCurrentFilters({
                contentType: payload.contentType,
                ageSpecific: payload.ageSpecific,
                subType: payload.subType,
                category: payload.category,
                speciality: payload.speciality,
            });
            setFiltersApplied(
                [
                    payload.contentType,
                    payload.ageSpecific,
                    payload.subType,
                    payload.category,
                    payload.speciality,
                ].filter((val) => val !== '').length
            );
            setSearchPayload(payload);
            setBrowsePayload(payload);
            setIsSearchPageStateRestored(false);
        } else {
            payload = {
                ...(isKeywordPresent ? searchPayload : browsePayload),
                start: offset,
            };
        }
        if (isKeywordPresent) {
            getSearchSkills(payload);
        } else {
            getBrowseSkillsOrPatientEducation(payload);
        }
        window.scrollTo(0, 0);
    };

    const handleChange = (name: string, value: string) => {
        setCurrentPage(1);
        const ageValue = Object.entries(AgeFilterTitles).find(
            ([, val]) => val[0] === value
        )?.[0];

        const getFacetValue = (val = value) => {
            let facetValue =
                searchFacetData
                    .find((item) => item.facetName === name)
                    ?.facetValues.find((item) => item.name === val)?.of || '';
            if (
                facetValue === '' &&
                name === HSearchFilters.AGESPECIFIC &&
                !Number.isNaN(Number(val))
            ) {
                const agefilter =
                    AgeFilterTitles[
                        Number(val) as keyof typeof AgeFilterTitles
                    ];
                const [, ageFilterValue] = agefilter;
                facetValue = ageFilterValue;
            }
            return facetValue.split('+')[1] || facetValue;
        };

        const modifiedValue = getFacetValue(value) || '';
        const isContentType = Object.values(HSearchContentType).includes(value);

        const browseOrSkillpayload = isKeywordPresent
            ? searchPayload
            : browsePayload;

        let updatedFilters = { ...currentFilters };
        switch (name) {
            case HSearchFilters.CONTENTTYPE:
                updatedFilters = {
                    contentType: value,
                    ageSpecific: '',
                    subType: '',
                    category: '',
                    speciality: '',
                };
                break;
            case HSearchFilters.AGESPECIFIC:
                updatedFilters.ageSpecific = getFacetValue(ageValue) || '';
                break;
            case HSearchFilters.PATIENTEDUCATIONTYPE:
                updatedFilters.subType = modifiedValue;
                break;
            case HSearchFilters.CATEGORIES:
                updatedFilters.category = modifiedValue;
                break;
            case HSearchFilters.SPECIALITIES:
                updatedFilters.speciality = modifiedValue;
                break;
            default:
                break;
        }
        setCurrentFilters(updatedFilters);
        setFiltersApplied(
            Object.values(updatedFilters).filter((val) => val !== '').length
        );
        const updatedPayload = {
            ...browseOrSkillpayload,
            keyword,
            contentType: updatedFilters.contentType,
            ageSpecific: updatedFilters.ageSpecific,
            subType: updatedFilters.subType,
            category: updatedFilters.category,
            speciality: updatedFilters.speciality,
            start: 0,
        };

        if (!isKeywordPresent) {
            updatedPayload.keyword = keyword;
        }

        if (isContentType) {
            updatedPayload.ageSpecific = '';
            updatedPayload.subType = '';
            updatedPayload.category = '';
            updatedPayload.speciality = '';
        }

        if (
            name === HSearchFilters.PATIENTEDUCATIONTYPE &&
            value === PatientEducationTypeTitles.MEDICATION
        ) {
            setIsSubTypeMedication(true);
            setSpeciality('');
            updatedPayload.speciality = '';
            setSelectedRadioOption((prev) => ({
                ...prev,
                [HSearchFilters.SPECIALITIES]: '',
            }));
        } else {
            setIsSubTypeMedication(false);
        }

        switch (name) {
            case HSearchFilters.CONTENTTYPE:
                setContentType(value);
                setAgeSpecific('');
                setSubType('');
                setCategory('');
                setSpeciality('');
                break;
            case HSearchFilters.AGESPECIFIC:
                setAgeSpecific(getFacetValue(ageValue) || '');
                break;
            case HSearchFilters.PATIENTEDUCATIONTYPE:
                setSubType(modifiedValue);
                break;
            case HSearchFilters.CATEGORIES:
                setCategory(modifiedValue);
                break;
            case HSearchFilters.SPECIALITIES:
                setSpeciality(modifiedValue);
                break;
            default:
                break;
        }

        setSelectedRadioOption({
            contentType:
                name === HSearchFilters.CONTENTTYPE ? value : contentType,
            ageSpecific:
                name === HSearchFilters.AGESPECIFIC
                    ? getFacetValue(ageValue)
                    : ageSpecific,
            subType:
                name === HSearchFilters.PATIENTEDUCATIONTYPE
                    ? modifiedValue
                    : subType,
            speciality:
                name === HSearchFilters.SPECIALITIES
                    ? modifiedValue
                    : speciality,
            category:
                name === HSearchFilters.CATEGORIES ? modifiedValue : category,
        });

        if (isKeywordPresent) {
            getSearchSkills(updatedPayload);
        } else {
            getBrowseSkillsOrPatientEducation(updatedPayload);
        }
        window.scrollTo(0, 0);
    };

    const onChangeSortByHandler = (selectedSortBy: SortByOption) => {
        const payload = {
            ...searchPayload,
            sortItem: selectedSortBy?.value?.includes('normalizeditemtitle')
                ? 'normalizeditemtitle'
                : selectedSortBy?.value,
            sortOrder: selectedSortBy?.value?.includes('desc') ? 'desc' : 'asc',
        };
        setSortBy(selectedSortBy?.label);
        setSortOrderBy(
            selectedSortBy?.value?.includes('desc') ? 'desc' : 'asc'
        );
        getSearchSkills(payload);
    };

    const onCloseBannerHandler = () => {
        setIsBannerVisible(!isBannerVisible);
    };

    const onCloseDefaultFilterBanner = () => {
        setIsDefaultFilterBannerVisible(false);
    };

    const getSearchSkills = (payload: any) => {
        setIsBannerVisible(false);
        setIsDefaultFilterBannerVisible(false);
        setSearchPayload(payload);
        if (payload?.keyword !== '') {
            dispatch(getAllHSearchSkills(payload));
        }
    };

    const getBrowseSkillsOrPatientEducation = async (payload: any) => {
        setIsBannerVisible(false);
        setIsDefaultFilterBannerVisible(false);
        setBrowsePayload(payload);

        dispatch(getBrowseSkillsOrPatientEducations(payload));
    };

    // const handleDefaultFilterButton = () => {
    //     setIsFilterSaveConfirmationModal(true);
    // }; // This code will be used in CLH Phase 4

    const handleUpdateDefaultFilter = async () => {
        setIsDefaultFilterBannerVisible(true);
        const payload = {
            clientId,
            userId,
            filterContent: { contentType: searchPayload.contentType },
        };
        if (favoriteFilters !== '') {
            dispatch(editFavoriteFilters(payload));
        } else {
            dispatch(postAddFavoriteFilters(payload));
        }
        setIsFilterSaveConfirmationModal(false);
    };

    const quickLinks = useSelector(selectQuickLinks);
    const quickLinksAsyncStatus = useSelector(selectQuickLinksAsyncStatus);
    const [isQuickLinksBannerVisible, setIsQuickLinksBannerVisible] =
        useState(true);
    const [searchPageAnnouncement, setSearchPageAnnouncement] = useState('');

    const onCloseQuickLinksBanner = () => {
        setIsQuickLinksBannerVisible(false);
    };

    useEffect(() => {
        if (hasFailed(quickLinksAsyncStatus)) {
            setIsQuickLinksBannerVisible(true);
        }
    }, [quickLinksAsyncStatus]);

    useEffect(() => {
        const searchFilterTitle = (
            contentType === HSearchContentType.CLINICALSKILLS
                ? NSKSearchFilter
                : PESearchFilter
        ).map((item: { name: string }) => item.name);
        let changePositionFacetData = searchFacetData;
        if (searchFilterTitle.includes(HSearchFilters.AGESPECIFIC)) {
            const findAgeIndex = searchFacetData.findIndex(
                (item: { facetName: string }) =>
                    item.facetName === HSearchFilters.AGESPECIFIC
            );
            if (findAgeIndex > 0) {
                const ageData = searchFacetData[findAgeIndex];
                const updatedAgeData = {
                    ...ageData,
                    facetValues: ageData.facetValues.map((data: any) => ({
                        ...data,
                        name:
                            AgeFilterTitles[
                                data.name as keyof typeof AgeFilterTitles
                            ]?.[0] || data.name,
                    })),
                };
                const updatedFacetShiftData = [
                    updatedAgeData,
                    ...searchFacetData.slice(0, findAgeIndex),
                    ...searchFacetData.slice(findAgeIndex + 1),
                ];
                changePositionFacetData = updatedFacetShiftData;
            }
        }

        let tempchangePositionFacetData = Array.isArray(changePositionFacetData)
            ? [...changePositionFacetData]
            : [];
        if (keyword.length > 0 && tempchangePositionFacetData.length > 0) {
            const requiredFilter = [
                HSearchFilters.SPECIALITIES,
                HSearchFilters.CATEGORIES,
            ];
            const existingNames = new Set(
                tempchangePositionFacetData.map((obj) => obj.facetName)
            );
            requiredFilter.forEach((name) => {
                if (!existingNames.has(name)) {
                    tempchangePositionFacetData.push({
                        facetName: name,
                        facetValues: [],
                    });
                }
            });
            tempchangePositionFacetData = [...tempchangePositionFacetData].sort(
                (a, b) =>
                    requiredFilter.indexOf(a.facetName) -
                    requiredFilter.indexOf(b.facetName)
            );
        }
        const facetData: any = tempchangePositionFacetData?.filter(
            (item: { facetName: string }) =>
                searchFilterTitle.includes(item.facetName) &&
                (!isSubTypeMedication ||
                    item.facetName !== HSearchFilters.SPECIALITIES)
        );
        setFilterFacetData(facetData);
    }, [searchFacetData, isSubTypeMedication]);

    const handleOnClosePill = (filterKey: string, filterValue: string) => {
        const facetNameMap: { [key: string]: string } = {
            speciality: HSearchFilters.SPECIALITIES,
            category: HSearchFilters.CATEGORIES,
            subType: HSearchFilters.PATIENTEDUCATIONTYPE,
            ageSpecific: HSearchFilters.AGESPECIFIC,
        };
        const newFilters = { ...currentFilters };
        if (newFilters[filterKey as keyof typeof newFilters] === filterValue) {
            if (filterKey in newFilters) {
                newFilters[filterKey as keyof typeof newFilters] = '';
            }
        }
        setCurrentPage(1);
        setCurrentFilters(newFilters);
        setFiltersApplied(
            Object.values(newFilters).filter((val) => val !== '').length
        );
        setAgeSpecific(newFilters.ageSpecific || '');
        setSubType(newFilters.subType || '');
        setCategory(newFilters.category || '');
        setSpeciality(newFilters.speciality || '');
        setSelectedRadioOption((prevRadio: any) => ({
            ...prevRadio,
            contentType,
            [filterKey]: '',
        }));
        if (facetNameMap[filterKey] === HSearchFilters.PATIENTEDUCATIONTYPE) {
            setIsSubTypeMedication(false);
        }
        const updatedPayload = {
            ...searchPayload,
            ...newFilters,
            start: 0,
            skillIds: allActiveSkillCourseIdentifier.join(','),
            contentType: newFilters.contentType,
            ageSpecific: newFilters.ageSpecific,
            subType: newFilters.subType,
            category: newFilters.category,
            speciality: newFilters.speciality,
            keyword,
        };

        if (!isKeywordPresent) {
            updatedPayload.keyword = '';
        }

        if (isKeywordPresent) {
            getSearchSkills(updatedPayload);
        } else {
            getBrowseSkillsOrPatientEducation(updatedPayload);
        }
        window.scrollTo(0, 0);
    };

    const getPaginationIndices = () => {
        let start = 0;
        let end = 0;
        if (totalNoOfRows > 0) {
            start = (currentPage - 1) * limit + 1;
            end = Math.min(currentPage * limit, totalNoOfRows);
        }
        return { start, end };
    };

    useEffect(() => {
        if (hasSucceeded(hSearchAsyncStatus) && searchSkillList !== undefined) {
            let message = '';
            if (searchSkillList.length === 0) {
                message = keyword
                    ? `No results found matching "${keyword}"`
                    : '';
            } else {
                const { start, end } = getPaginationIndices();
                if (filtersApplied > 0 && keyword) {
                    message = `Page ${currentPage}. 
                    Showing ${start} to ${end} of ${totalNoOfRows} 
                    results ${keyword ? ` matching "${keyword}"` : ''}.
                     ${filtersApplied} ${
                        filtersApplied === 1 ? 'filter' : 'filters'
                    } active.`;
                }
                if (filtersApplied > 1) {
                    message = `Page ${currentPage}. 
                    Showing ${start} to ${end} of ${totalNoOfRows} 
                    results ${filtersApplied} 
                    ${filtersApplied === 1 ? 'filter' : 'filters'} active.`;
                }
                message = `Page ${currentPage}. Showing 
                ${start} to ${end} of ${totalNoOfRows} results
                ${keyword ? ` matching "${keyword}"` : '.'} 
                ${filtersApplied} ${
                    filtersApplied === 1 ? 'filter' : 'filters'
                } active.`;
            }
            if (message) {
                setTimeout(() => {
                    setSearchPageAnnouncement(message);
                }, 300);
            }
        }
    }, [
        hSearchAsyncStatus,
        searchSkillList,
        currentPage,
        totalNoOfRows,
        keyword,
        filtersApplied,
    ]);

    useEffect(() => {
        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    const handleMessage = (event: MessageEvent) => {
        // Handle self enrollment update event from parent window (POC)
        // to update the enrollment status in Connect Player.
        if (
            event?.data?.eventName === SELF_ENROLLMENT_UPDATE_EVENT &&
            event.origin === appConfigs.CONNECT_ADAPTER_BASE_URL &&
            event.data?.courseId
        ) {
            dispatch(
                setEventSelfEnrolledCourseId({
                    courseId: event.data.courseId,
                })
            );
        }
    };

    const { start: startIndexDisplay, end: endIndexDisplay } =
        getPaginationIndices();

    return (
        <div className={`${baseClassName}`}>
            <PageTitle title="Search | Clinical Skills" />
            <AriaLiveAnnouncer
                message={searchPageAnnouncement}
                setAlert={setSearchPageAnnouncement}
            />
            <div id="content" tabIndex={-1}>
                <h1 className="u-els-hide-visually">
                    Clinical Skills search results
                </h1>
            </div>

            {isOverlayLoaderVisible && <Loader isVisible isBlocking />}

            {isOverlayVisible && (
                <div className={`${baseClassName}__overlay`}>
                    <LeftFilterPanel
                        baseClassName={`${baseClassName}`}
                        toggleOverlay={toggleOverlay}
                        borderWeight="none"
                        onHandleChange={handleChange}
                        selectedContentType={contentType}
                        searchFacetData={filterFacetData}
                        totalNoOfRows={totalNoOfRows}
                        currentFilters={currentFilters}
                        setSelectedRadioOption={setSelectedRadioOption}
                        selectedRadioOption={selectedRadioOption}
                        contentTypeLicensedByClient={
                            contentTypeLicensedByClient
                        }
                        contentTypeLicensedAsyncStatus={
                            contentTypeLicensedAsyncStatus
                        }
                        resultDetails={
                            totalNoOfRows
                                ? `${startIndexDisplay} to ${endIndexDisplay} of ${totalNoOfRows}`
                                : ''
                        }
                    />
                </div>
            )}
            {!isOverlayVisible && (
                <div className={`${baseClassName}__filter-section`}>
                    <LeftFilterPanel
                        baseClassName={baseClassName}
                        onHandleChange={handleChange}
                        selectedContentType={contentType}
                        searchFacetData={filterFacetData}
                        setSelectedRadioOption={setSelectedRadioOption}
                        selectedRadioOption={selectedRadioOption}
                        contentTypeLicensedByClient={
                            contentTypeLicensedByClient
                        }
                        contentTypeLicensedAsyncStatus={
                            contentTypeLicensedAsyncStatus
                        }
                        resultDetails={
                            totalNoOfRows
                                ? `${startIndexDisplay} to ${endIndexDisplay} of ${totalNoOfRows}`
                                : ''
                        }
                    />
                </div>
            )}
            <div className={`${baseClassName}__content-section`}>
                {contentType === HSearchContentType.CLINICALSKILLS &&
                    hasFailed(enrolledSkillsAsyncStatus) && (
                        <div
                            className={`${baseClassName}__content-section__enrolled-skills-banner`}
                        >
                            <Banner
                                isVisible={isEnrolledSkillsBannerVisible}
                                isFilled
                                type="warn"
                                hideCloseLabel
                                onClose={onCloseEnrolledSkillsBanner}
                            >
                                Your self-enrollment status is temporarily
                                unavailable. Refresh the page to try again.
                            </Banner>
                        </div>
                    )}
                <AutoSuggestComponent
                    onHandleSearchClick={handleSearchClick}
                    keyword={keyword}
                    allActiveSkillsDetails={allActiveSkillsDetails}
                    contentTypeLicensedByClient={contentTypeLicensedByClient}
                    contentTypeLicensedAsyncStatus={
                        contentTypeLicensedAsyncStatus
                    }
                    saveSearchState={saveSearchState}
                    contentType={contentType}
                />
                {showCancelSuccessToast && (
                    <div
                        className={`${baseClassName}__cancel-enrollment-success-toast-overlay`}
                        role="alert"
                    >
                        <Toast
                            autoHide
                            color="confirm"
                            className={`${baseClassName}__cancel-enrollment-success-toast`}
                        >
                            <div
                                className={`${baseClassName}__cancel-enrollment-success-toast__content`}
                            >
                                <div>
                                    <p>Enrollment cancelled.</p>
                                    <p>You can re-enroll at any time.</p>
                                </div>
                            </div>
                        </Toast>
                    </div>
                )}
                <div className={`${baseClassName}__content-section__buttons`}>
                    <div
                        className={`${baseClassName}__content-section__buttons__filter-btn-for-mobile`}
                    >
                        <Button
                            type="secondary"
                            size="small"
                            onClick={toggleOverlay}
                        >
                            Filters{' '}
                            {filtersApplied > 0 && `(${filtersApplied})`}
                        </Button>
                    </div>
                    {searchSkillList?.length > 0 && (
                        <div
                            className={`${baseClassName}__content-section__buttons__default-filter`}
                        >
                            <SelectedPills
                                handleOnClosePill={handleOnClosePill}
                                currentFilters={currentFilters}
                                searchFacetData={searchFacetData}
                            />
                            {/* <DefaultFilterButton
                                baseClassName={`${baseClassName}__content-section__buttons`}
                                handleDefaultFilterButton={
                                    handleDefaultFilterButton
                                }
                                favoriteFilters={favoriteFilters}
                                selectedFilters={{ contentType }}
                            /> // This code will be used in CLH Phase 4 */}
                        </div>
                    )}
                </div>
                <div>
                    {isKeywordPresent &&
                        isPending(hSearchAsyncStatus) &&
                        sortBy === relevanceFilterDropdown[3].label && (
                            <div
                                className={`${baseClassName}__content-section__total-result__dropdown-loading-view-mobile`}
                            >
                                <span className="title">Sort by:</span>
                                <Dropdown
                                    id="dropdown-loading-mobile"
                                    options={relevanceFilterDropdown}
                                    label={sortBy}
                                    onChange={onChangeSortByHandler}
                                    placement="bottom-end"
                                    shouldCloseOnESC
                                />
                            </div>
                        )}
                </div>
                {hasFailed(hSearchAsyncStatus) && (
                    <WarnBanner
                        name="search"
                        isBannerVisible={isBannerVisible}
                        onCloseBannerHandler={onCloseBannerHandler}
                    />
                )}
                {hasFailed(hscsAsyncStatus) && (
                    <WarnBanner
                        name="printing Patient Education content"
                        baseClassName={baseClassName}
                        isBannerVisible={isBannerVisible}
                        onCloseBannerHandler={onCloseBannerHandler}
                    />
                )}
                {isComplete(isReferentialAsyncStatus) &&
                    isComplete(isIpWhitelistedAsyncStatus) &&
                    (isPending(hSearchAsyncStatus) ||
                        isPending(allSkillAsyncStatus)) && (
                        <Loader
                            isVisible
                            isBlocking={false}
                            className={`${baseClassName}-loader`}
                        />
                    )}
                {hasSucceeded(hSearchAsyncStatus) &&
                    searchSkillList?.length === 0 && (
                        <>
                            <span className="u-els-hide-visually">
                                {keyword
                                    ? `No results found matching "${keyword}"`
                                    : 'No content matches this search.'}
                            </span>
                            <NoSearchResults mainText="No content matches this search." />
                        </>
                    )}
                {searchSkillList?.length > 0 && (
                    <>
                        {(hasFailed(addOrEditFavoriteFiltersStatus) ||
                            hasFailed(getFavoriteFiltersStatus)) && (
                            <WarnBanner
                                name="default filters"
                                isBannerVisible={isDefaultFilterBannerVisible}
                                onCloseBannerHandler={
                                    onCloseDefaultFilterBanner
                                }
                            />
                        )}
                        {contentType === HSearchContentType.CLINICALSKILLS &&
                            hasFailed(quickLinksAsyncStatus) && (
                                <WarnBanner
                                    name="quick links"
                                    isBannerVisible={isQuickLinksBannerVisible}
                                    onCloseBannerHandler={
                                        onCloseQuickLinksBanner
                                    }
                                    isNamePlural
                                />
                            )}
                        <div
                            className={`${baseClassName}__content-section__total-result`}
                        >
                            <div
                                className={
                                    isKeywordPresent &&
                                    sortBy === relevanceFilterDropdown[3].label
                                        ? `${baseClassName}__content-section__total-result__filter-mobile`
                                        : `${baseClassName}__content-section__total-result__filter`
                                }
                            >
                                <span className="u-els-hide-visually">
                                    Page {currentPage}. Showing{' '}
                                    {startIndexDisplay}
                                    to {endIndexDisplay} of {totalNoOfRows}
                                    results
                                    {keyword ? ` matching "${keyword}"` : '.'}
                                    {filtersApplied}{' '}
                                    {filtersApplied === 1
                                        ? 'filter'
                                        : 'filters'}{' '}
                                    active.
                                </span>
                                <span
                                    className={`${baseClassName}__content-section__total-result__filter__title-for-desktop`}
                                >
                                    {`Showing ${startIndexDisplay}-${endIndexDisplay} of ${totalNoOfRows} results`}
                                </span>
                                <span
                                    className={`${baseClassName}__content-section__total-result__filter__title-for-mobile`}
                                >
                                    {`${totalNoOfRows} Results`}
                                </span>
                                {isKeywordPresent && (
                                    <div
                                        className={`${baseClassName}__content-section__total-result__dropdown-for-desktop`}
                                    >
                                        <span className="title">Sort by:</span>
                                        <Dropdown
                                            id="dropdown-desktop-results"
                                            options={relevanceFilterDropdown}
                                            label={sortBy}
                                            onChange={onChangeSortByHandler}
                                            placement="bottom-end"
                                            shouldCloseOnESC
                                        />
                                    </div>
                                )}
                                {isKeywordPresent &&
                                    sortBy !==
                                        relevanceFilterDropdown[3].label && (
                                        <div
                                            className={`${baseClassName}__content-section__total-result__dropdown-for-mobile`}
                                        >
                                            <span className="title">
                                                Sort by:
                                            </span>
                                            <Dropdown
                                                id="dropdown-mobile-results"
                                                options={
                                                    relevanceFilterDropdown
                                                }
                                                label={sortBy}
                                                onChange={onChangeSortByHandler}
                                                placement="bottom-end"
                                                shouldCloseOnESC
                                            />
                                        </div>
                                    )}
                                {isKeywordPresent &&
                                    sortBy ===
                                        relevanceFilterDropdown[3].label && (
                                        <div
                                            className={`${baseClassName}__content-section__total-result__dropdown-loading-view-mobile`}
                                        >
                                            <span className="title">
                                                Sort by:
                                            </span>
                                            <Dropdown
                                                id="dropdown-mobile-recently-updated"
                                                options={
                                                    relevanceFilterDropdown
                                                }
                                                label={sortBy}
                                                onChange={onChangeSortByHandler}
                                                placement="bottom-end"
                                                shouldCloseOnESC
                                            />
                                        </div>
                                    )}
                            </div>
                        </div>
                        <span
                            id="listDescription"
                            className="u-els-hide-visually"
                        >
                            Search Results,
                        </span>
                        <ul
                            aria-labelledby="listDescription"
                            className={`${baseClassName}__content-section__body`}
                        >
                            {searchSkillList.map(
                                (
                                    skill: IHSearchSkillDetails,
                                    index: number
                                ) => (
                                    <li key={skill.eid}>
                                        <SearchedSkillCard
                                            counts={{
                                                index: index + 1,
                                                total: searchSkillList.length,
                                            }}
                                            baseClassName={baseClassName}
                                            cardType={contentType}
                                            title={skill.itemtitle}
                                            description={skill.abs}
                                            searchedSkillId={skill.skillid}
                                            allActiveSkillsDetails={
                                                allActiveSkillsDetails
                                            }
                                            courseContentType={
                                                skill.courseContentType
                                            }
                                            isUserAdmin={isUserAdmin}
                                            eid={skill.eid}
                                            spanishLanguageId={
                                                skill.altlang?.reduce<string>(
                                                    (acc, lang, index) => {
                                                        if (
                                                            lang === 'es' &&
                                                            skill.altlangeid
                                                        ) {
                                                            acc =
                                                                skill
                                                                    .altlangeid[
                                                                    index
                                                                ];
                                                        }
                                                        return acc;
                                                    },
                                                    ''
                                                ) || ''
                                            }
                                            languageCode={englishLanguageCode}
                                            quickLinks={quickLinks}
                                            quickLinksAsyncStatus={
                                                quickLinksAsyncStatus
                                            }
                                            CE={skill.CE}
                                            hasCE={skill.hasCE}
                                            saveSearchState={saveSearchState}
                                            selfEnrollment={
                                                selfEnrollmentIdBySkillId[
                                                    skill.courseId
                                                ]
                                            }
                                            setOverlayLoaderVisible={
                                                setOverlayLoaderVisible
                                            }
                                            setShowCancelSuccessToast={
                                                setShowCancelSuccessToast
                                            }
                                            index={index}
                                        />
                                    </li>
                                )
                            )}
                        </ul>
                        <div
                            className={`${baseClassName}__content-section__pagination`}
                        >
                            <Paginator
                                a11y={{
                                    name: 'Content-Page',
                                    pagingUnitName: 'Page',
                                    morePagingUnit: 'More pages',
                                }}
                                shouldShowPrevNextLabel
                                className="els-pagination"
                                currentPage={currentPage}
                                onPageChange={onPageChangeHandler}
                                resultsPerPage={limit}
                                maxPagesToShow={10}
                                totalResults={totalNoOfRows}
                                isMobileView={isMobileView}
                            />
                        </div>
                    </>
                )}
            </div>
            {isFilterSaveConfirmationModal && (
                <DefaultFilterConfirmationModal
                    setIsModalOpen={setIsFilterSaveConfirmationModal}
                    handleAddDefaultFilters={handleUpdateDefaultFilter}
                    favoriteFilters={favoriteFilters}
                    selectedFilters={{ contentType }}
                />
            )}
        </div>
    );
};
export default BackButtonNavigationTracking('Search', Search);
